export default __webpack_public_path__ + "static/media/small.a5e6fb35.jpg";